export default __webpack_public_path__ + "ff0a17f77033bd8a9174ed0093d96e6f.png";